// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import { FormattedMessage } from 'react-intl';
import Loading from '../Loading/Loading';

import style from './SuccessErrorModal.scss';
import yogi from '../../assets/img/home/yogi-qempo_2.png';


type Props = {
  +color: 'orange' | 'lightBlue';
  +isLoading?: boolean;
  +success?: boolean;
  +error?: boolean;
  +isOpen?: boolean;
  +titleInt?: string;
  +textInt?: string;
  +title?: string;
  +text?: string;
  +handleCloseModal: () => void;
};

type State = {};

export default class SuccessErrorModal extends Component<Props, State> {


  builderScene() {
    const { isLoading, success, error, titleInt, textInt, color, title, text } = this.props;
    if (isLoading) {
      return <Loading type="circle"
                      color={color}
                      className={style.modalLoading}
                      number={3}/>
    } else if (success) {
      return <Fragment>
        <img className={style.yogi}
             src={yogi}
             alt="happy yogi"/>
        {titleInt && <FormattedMessage id={titleInt}>{
          text => <h2 className={color === 'lightBlue' ? style.lightBlue : style.orange}>{text}</h2>
        }</FormattedMessage>}
        {title && <h2 className={color === 'lightBlue' ? style.lightBlue : style.orange}>{title}</h2>}
        {textInt && <FormattedMessage id={textInt}>{
          text => <p>{text}</p>
        }</FormattedMessage>}
        {text && <p>{text}</p>}
      </Fragment>
    } else if (error) {
      return <Fragment>
        <img className={style.yogi}
             src={yogi}
             alt="happy yogi"/>
        {titleInt && <FormattedMessage id={titleInt}>{
          text => <h2>{text}</h2>
        }</FormattedMessage>}
        {title && <h2 className={color === 'lightBlue' ? style.lightBlue : style.orange}>{title}</h2>}
        {textInt && <FormattedMessage id={textInt}>{
          text => <p>{text}</p>
        }</FormattedMessage>}
        {text && <p>{text}</p>}
      </Fragment>
    }
  }

  render() {
    const { isOpen, handleCloseModal } = this.props;
    return (
      <Modal open={isOpen}
             width={544}
             height={356}
             handleClose={handleCloseModal}>
        <section className={style.successErrorModal}>
          {this.builderScene()}
        </section>
      </Modal>
    );
  }
}

SuccessErrorModal.propTypes = {
  color: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.bool,
  isOpen: PropTypes.bool,
  titleInt: PropTypes.string,
  textInt: PropTypes.string,
  handleCloseModal: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/SuccessErrorModal/SuccessErrorModal.jsx